import { api } from 'shared/api'

import { groupsApiSchemas } from './schemas'

export const GroupsApi = {
  list: api.account.createGet({
    url: '/groups/list',
    schemas: groupsApiSchemas.list,
  }),
  create: api.account.createPost({
    url: '/groups/create',
    schemas: groupsApiSchemas.create,
  }),
  delete: api.account.createPost({
    url: '/groups/delete',
    schemas: groupsApiSchemas.delete,
  }),
  update: api.account.createPost({
    url: '/groups/update',
    schemas: groupsApiSchemas.update,
  }),
  switchAutoAssign: api.account.createPost({
    url: '/groups/switchAutoAssign',
    schemas: groupsApiSchemas.swithcAutoAssign,
    scope: 'livechat',
    section: 'auto_assignment',
  }),
  changeUsers: api.account.createPost({
    url: '/groups/changeUsers',
    schemas: groupsApiSchemas.changeUsers,
  }),
}
